import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { getLanguage } from '../../features/app/selectors';
import Translate from './Translate';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';

const PpsiBasicList = ({ ppsis }) => {
  const language = useSelector(getLanguage);
  const sortedPpsis = _.sortBy(
    ppsis,
    `publishedPpsiEnrichmentData.info.${language}.presentationName`
  );
  return (
    <div>
      {sortedPpsis.map(ppsi => (
        <div key={ppsi.id}>
          <Translate
            language={language}
            info={ppsi.publishedPpsiEnrichmentData.info}
            field="presentationName"
          />
          {`  -  ${ppsi.formulaCode}`}
        </div>
      ))}
    </div>
  );
};

PpsiBasicList.propTypes = {
  ppsis: PropTypes.array.isRequired
};

export default ImmutablePropsToJS(PpsiBasicList);
